"use strict";

/**
 * Desktop under video banner
 */
;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);
  // refresh banners after new related videos loaded
  document.addEventListener('flix:additional-related', onPageLoad);

  /**
   * Check if this ad should be shown
   * @returns boolean
   */
  function isEnabled() {
    return Flix.ads.enabled && FlixUtils.isDesktop() // desktop only
    && !!document.querySelector('#ads-under-video'); // video page
  }
  ;

  /**
   * Main logic
   */
  function onPageLoad() {
    if (!isEnabled()) {
      return;
    }
    if (Flix.isTna()) {
      var code = "<iframe class=\"na\" style=\"max-width:100%\" frameborder=\"0\" scrolling=\"no\" width=\"728\" height=\"90\" sandbox=\"allow-scripts allow-popups allow-forms allow-same-origin\"\n                src=\"//a.shukriya90.com/api/spots/350558?p=1&s1=".concat(Flix.ads.iid, "'&kw=").concat(Flix.ads.tags, "\"></iframe>");
    } else {
      var code = "<iframe class=\"na\" style=\"max-width:100%\" frameborder=\"0\" scrolling=\"no\" width=\"728\" height=\"90\" sandbox=\"allow-scripts allow-popups allow-forms allow-same-origin\" \n                src=\"//a.shukriya90.com/api/spots/350568?p=1&s1=".concat(Flix.ads.iid, "&kw=").concat(Flix.ads.tags, "\"></iframe>");
    }
    document.querySelector('#ads-under-video').innerHTML = code;
  }
  ;
})();